import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ClickOutside from '../../views/common/ClickOutside';

class NavMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = { menuDisplayed: false };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  showNavMenu(show) {
    this.props.displayHandler(show);
    this.setState({ menuDisplayed: show });
  }

  handleClickOutside() {
    this.showNavMenu(false);
  }

  handleMenuClick() {
    if (!this.state.menuDisplayed) {
      this.showNavMenu(true);
    } else {
      this.showNavMenu(false);
    }
  }

  handleSubmenuItemClick(value, evt) {
    evt.stopPropagation();
    this.showNavMenu(false);

    let redirectLinks = this.props.redirectLinks;
    let redirectLink = redirectLinks[_.camelCase(value)];

    redirectLink();
  }

  renderNavSubmenu() {
    let { submenu } = this.props;

    return _.map(submenu, (value, key) => {
      return (
        <div
          role="menuitem"
          className="ui-menu__item"
          key={key}
          onClick={this.handleSubmenuItemClick.bind(this, value)}
        >
          <span>{value}</span>
          {this.renderSubmenuDetails(value)}
        </div>
      );
    });
  }

  renderSubmenuDetails(value) {
    let { submenuDetails } = this.props;

    if (submenuDetails) {
      return <span className="right-align "> ({submenuDetails[value]})</span>;
    }
  }

  renderNavMenu() {
    let { display, menuTitle } = this.props;

    return (
      <div>
        <div className="menu-text">{menuTitle}</div>
        <div
          className="ui-paper"
          style={{
            position: 'absolute',
            top: '50px',
            right: '10px',
            display: display ? 'block' : 'none',
            textAlign: 'left',
          }}
        >
          <div className="ui-menu" role="menu">
            {display && (
              <ClickOutside handleClickOutside={this.handleClickOutside}>
                <>{this.renderNavSubmenu()}</>
              </ClickOutside>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div onClick={this.handleMenuClick}>
        {this.props.navElement}
        {this.renderNavMenu()}
      </div>
    );
  }
}

NavMenu.propTypes = {
  display: PropTypes.bool.isRequired,
  displayHandler: PropTypes.func.isRequired,
  redirectLinks: PropTypes.object.isRequired,
  navElement: PropTypes.element.isRequired,
  menuTitle: PropTypes.element.isRequired,
  submenu: PropTypes.object.isRequired,
};

export default NavMenu;
